import React, { useState, forwardRef } from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { COLORES } from '../../../../config/colores'

function InputTable (props, ref) {
  const { name, value, icono = null, max = null, min = 0, justifyContent = 'space-around', colorValue = null, backgroundInput = null, fontSizeInput = null } = props
  const [isEditing, setIsEditing] = useState(false)

  const handleDisplayClick = () => {
    setIsEditing(true)
    props.handleDisplay()
  }

  const handleInputBlur = () => {
    props.handleBlur()
    setIsEditing(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur()
    }
  }

  return (
    <div ref={ref} style={{ display: 'flex', justifyContent: justifyContent, padding: 0, margin: 0 }} >
      {isEditing
        ? <Field
          onKeyDown={handleKeyDown}
          name={name}
          type='number'
          label=' '
          max={max}
          min={min}
          component={(fieldProps) => (
            renderTextField({
              ...fieldProps,
              onBlur: handleInputBlur,
              wrapperStyle: {
                margin: 0,
                padding: 0,
                // minHeight: 'auto',
                marginBottom: 0,
                width: '100%',
                fontSize: fontSizeInput || '10px',
                backgroundColor: backgroundInput || 'transparent'
              },
              style: { padding: 0, margin: 0 }
            })
          )}
          autoFocus
          style={{
            padding: 0,
            margin: 0,
            width: 'auto',
            color: colorValue || COLORES.grey.dark
          }}
        />
        : <div
          onClick={handleDisplayClick}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            justifyContent: 'center'
          }}
        >
          <span
            style={{
              color: colorValue || COLORES.grey.dark,
              fontWeight: 'bold',
              marginRight: '5px',
              backgroundColor: backgroundInput || 'transparent',
              fontSize: fontSizeInput || 'inherit'
            }}
          >
            { value }
          </span>
          { icono && icono }
        </div>
      }
    </div>
  )
}

export default forwardRef(InputTable)
